import React from "react"

import { StudyTeamMemberFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchStudyTeamMember {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: StudyTeamMemberFilters
    onFilter: (filters: StudyTeamMemberFilters) => void
}

const StudyTeamMemberSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchStudyTeamMember) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default StudyTeamMemberSearch
